"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var vega_embed_1 = __importDefault(require("vega-embed"));

var render_utils_1 = require("./render_utils");

function confusionMatrix(container, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var options, drawArea, values, inputArray, tickLabels, generateLabels, nonDiagonalIsAllZeroes, i, label, j, prediction, count, _i, _values, val, embedOpts, spec;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = Object.assign({}, defaultOpts, opts);
            drawArea = render_utils_1.getDrawArea(container);
            values = [];
            inputArray = data.values;
            tickLabels = data.tickLabels || [];
            generateLabels = tickLabels.length === 0;
            nonDiagonalIsAllZeroes = true;

            for (i = 0; i < inputArray.length; i++) {
              label = generateLabels ? "Class ".concat(i) : tickLabels[i];

              if (generateLabels) {
                tickLabels.push(label);
              }

              for (j = 0; j < inputArray[i].length; j++) {
                prediction = generateLabels ? "Class ".concat(j) : tickLabels[j];
                count = inputArray[i][j];

                if (i === j && !options.shadeDiagonal) {
                  values.push({
                    label: label,
                    prediction: prediction,
                    diagCount: count,
                    noFill: true
                  });
                } else {
                  values.push({
                    label: label,
                    prediction: prediction,
                    count: count
                  });

                  if (count !== 0) {
                    nonDiagonalIsAllZeroes = false;
                  }
                }
              }
            }

            if (!options.shadeDiagonal && nonDiagonalIsAllZeroes) {
              for (_i = 0, _values = values; _i < _values.length; _i++) {
                val = _values[_i];

                if (val.noFill === true) {
                  val.noFill = false;
                  val.count = val.diagCount;
                }
              }
            }

            embedOpts = {
              actions: false,
              mode: 'vega-lite',
              defaultStyle: false
            };
            spec = {
              'width': options.width || drawArea.clientWidth,
              'height': options.height || drawArea.clientHeight,
              'padding': 0,
              'autosize': {
                'type': 'fit',
                'contains': 'padding',
                'resize': true
              },
              'config': {
                'axis': {
                  'labelFontSize': options.fontSize,
                  'titleFontSize': options.fontSize
                },
                'text': {
                  'fontSize': options.fontSize
                },
                'legend': {
                  'labelFontSize': options.fontSize,
                  'titleFontSize': options.fontSize
                }
              },
              'data': {
                'values': values
              },
              'encoding': {
                'x': {
                  'field': 'prediction',
                  'type': 'ordinal',
                  'scale': {
                    'domain': tickLabels
                  }
                },
                'y': {
                  'field': 'label',
                  'type': 'ordinal',
                  'scale': {
                    'domain': tickLabels
                  }
                }
              },
              'layer': [{
                'mark': {
                  'type': 'rect'
                },
                'encoding': {
                  'fill': {
                    'condition': {
                      'test': 'datum["noFill"] == true',
                      'value': 'white'
                    },
                    'field': 'count',
                    'type': 'quantitative',
                    'scale': {
                      'range': ['#f7fbff', '#4292c6']
                    }
                  },
                  'tooltip': {
                    'condition': {
                      'test': 'datum["noFill"] == true',
                      'field': 'diagCount',
                      'type': 'nominal'
                    },
                    'field': 'count',
                    'type': 'nominal'
                  }
                }
              }]
            };

            if (options.showTextOverlay) {
              spec.layer.push({
                'mark': {
                  'type': 'text',
                  'baseline': 'middle'
                },
                'encoding': {
                  'text': {
                    'condition': {
                      'test': 'datum["noFill"] == true',
                      'field': 'diagCount',
                      'type': 'nominal'
                    },
                    'field': 'count',
                    'type': 'nominal'
                  }
                }
              });
            }

            _context.next = 14;
            return vega_embed_1.default(drawArea, spec, embedOpts);

          case 14:
            return _context.abrupt("return", Promise.resolve());

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.confusionMatrix = confusionMatrix;
var defaultOpts = {
  xLabel: null,
  yLabel: null,
  xType: 'nominal',
  yType: 'nominal',
  shadeDiagonal: true,
  fontSize: 12,
  showTextOverlay: true,
  height: 400
};